export default __webpack_public_path__ + "static/media/login-img.49284ad6.png";